angular.module('bfControllers.pallets', []).controller(
    'PalletsController',
    ['$scope', '$rootScope', '$http', '$resource', '$cookies', 'helpers', 'subbuyer',
    function ($scope, $rootScope, $http, $resource, $cookies, helpers, subbuyer)
{
    $scope.subbuyer = subbuyer;
    this.palletsList = {};
    this.per_page = 10;
    $scope.pagination = new helpers.pagination(this.per_page, 30);

    $rootScope.sort = 'id';
    $rootScope.direct = 'desc';

    var self = this;

    /**
     * Get list of Pallets
     * http://ec.term.biflorica:10000/api/Subbuyers/palletList?page=1
     */
    this.getPallets = function() {
        $rootScope.querySent = true;
        $resource(API_LINK + '/:action',
            {
                action:'Subbuyers/palletList',
                import_type_id: $('#import_type_filter').attr('value'),
                page: $scope.pagination.currPage
            },
            {get: {method:'GET'}}
        ).get(function(result) {
            self.palletsList = result.data.list;
            $scope.pallets = result.data.list;
            var count = parseInt(result.data.count_items);
            var total = parseInt(result.data.total_items);
            $scope.pagination.recountPages(count, total);
            $rootScope.querySent = false;
        });
    };
    $rootScope.renewPallets = $scope.pagination.renewPage = this.getPallets;

    $scope.setTypeFilter = function(e) {
        $('#import_type_filter').val($(e.currentTarget).attr('value'));
        $('#import_type_title_filter').html($(e.target).text());
        $rootScope.renewPallets();
    }

    /**
     * Действия, которые необходимо выполнить после восстановления соединения с сервером ноды
     */
    $rootScope.$on('afterReconnect', function(event, data) {
        $rootScope.renewPallets();
    });

    // Действия после загрузки страницы
    this.getPallets();
}]);
